"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function ServiceProcess() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const steps = [{
    number: "01",
    title: "INITIAL CONSULTATION",
    description: "We discuss your specific roofing needs or property goals to determine the best path forward."
  }, {
    number: "02",
    title: "EXPERT ASSESSMENT",
    description: "Our team conducts a thorough inspection of your property to identify all necessary repairs or solutions."
  }, {
    number: "03",
    title: "EXECUTION & RESULTS",
    description: "We deliver professional construction services or a fair cash offer with speed and precision."
  }];
  return <section data-section-id="3913" id="where-we-work" className="relative dark bg-background overflow-hidden min-h-[75vh] flex items-center py-16 lg:py-0">
      <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center">
        {}
        <div ref={leftRef} className={`lg:col-span-6 px-6 md:px-12 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex items-center gap-4 mb-10">
            <span className="h-px w-12 bg-primary" />
            <span className="font-mono text-xs tracking-[0.25em] uppercase" style={{
            color: "var(--primary)"
          }}>
              Our Process
            </span>
            <span className="h-px w-12 bg-primary" />
          </div>

          {}
          <h1 className="font-default font-semibold text-foreground leading-[1.0] mb-8" style={{
          fontSize: "clamp(2.8rem, 5vw + 1rem, 5rem)"
        }}>
            A <em className="italic font-default font-light" style={{
            color: "var(--primary)"
          }}>streamlined</em>
            <br />
            approach to
            <br />
            construction.
          </h1>

          {}
          <p className="font-default text-base md:text-lg leading-relaxed max-w-[440px] mb-12" style={{
          color: "var(--muted-foreground)"
        }}>
            Luxury Construction LLC simplifies your property needs. From professional roofing inspections to nationwide cash home buying, we ensure a transparent, efficient, and high-quality experience every step of the way.
          </p>

          {}
          <div className="max-w-[480px] mb-12">
            {steps.map((step, i) => <div key={i} data-index={i} className={`grid grid-cols-[auto_1fr] gap-6 py-6 ${i !== steps.length - 1 ? "border-b border-border" : ""} ${i === 0 ? "border-t border-border" : ""}`}>
                <span className="font-default text-3xl md:text-4xl font-semibold text-foreground leading-none pt-1">
                  {step.number}
                </span>
                <div>
                  <h3 className="font-default text-xs tracking-[0.25em] uppercase text-foreground mb-2 font-medium">
                    {step.title}
                  </h3>
                  <p className="font-default text-sm leading-relaxed" style={{
                color: "var(--muted-foreground)"
              }}>
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>

          {}
          <Link to="/ContactUsPage">
            <Button size="lg" className="font-default text-xs tracking-[0.25em] uppercase h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90">
              Get Started Today
              <ArrowRight className="ml-1 h-4 w-4" />
            </Button>
          </Link>
        </div>

        {}
        <div ref={rightRef} className={`lg:col-span-6 relative w-full h-full transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          <div className="relative w-full aspect-[3/4] lg:aspect-auto lg:h-[75vh] overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_inspection_professional.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_inspection_professional.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_inspection_professional.webp-wvc-sizes" alt="Professional roofing contractor performing a detailed inspection on a residential property" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

            {}
            <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 bg-background border border-border p-6 md:p-7 max-w-[280px] shadow-lg">
              <div className="flex items-center gap-3 mb-3">
                <span className="h-px w-6 bg-primary" />
                <span className="font-mono text-[10px] tracking-[0.25em] uppercase" style={{
                color: "var(--primary)"
              }}>
                  Service Standards
                </span>
              </div>
              <p className="font-mono text-xs tracking-[0.2em] uppercase text-foreground leading-relaxed mb-2">
                Fast Response
                <br />
                <span style={{
                color: "var(--muted-foreground)"
              }}>24/7 Support</span>
              </p>
              <div className="h-px w-full bg-border my-3" />
              <p className="font-mono text-xs tracking-[0.2em] uppercase text-foreground">
                Nationwide
                <br />
                <span style={{
                color: "var(--muted-foreground)"
              }}>Cash Offers</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}